module.exports = "/images/whatsAppIcon.svg";